<!-- <template>
  <div
    class="ui steps"
    :class="{ordered: ordered}"
  >
    <div
      v-for="step in steps"
      :key="step.index"
      class="step"
      :class="{completed: step.completed, active: step.active, disabled: step.disabled}"
      @click="$emit(`click${step.index}`)"
    >
      <div class="content">
        <p class="title">{{step.title}}</p>
        <p
          v-if="step.description"
          class="description"
        >{{step.description}}</p>
      </div>
    </div>
  </div>
</template> -->

<template>
	<div class="ui ordered steps">
		<slot />
	</div>
</template>

<script>
export default {
	props: {
		ordered: {
			type: Boolean,
			default: false,
		},
	},
}
</script>

<style scoped>
.ui.ordered.steps {
	position: relative;
	width: 100%;
}

.step {
	width: min-content;
	padding: 0;
}

.ui.ordered.steps .step:before {
	font-size: 1.5rem;
}

.ui.steps .step:first-child {
	padding-left: 1em;
	border-radius: 0.28571429rem 0 0 0.28571429rem;
}

.ui.step,
.ui.steps .step {
	font-size: 0.8rem;
	cursor: pointer;
}

.title {
	font-size: 1rem !important;
	line-height: 1rem !important;
}

p {
	line-height: 0.7rem;
	margin-bottom: 0;
}

@media screen and (min-device-width: 1200px) and (max-device-width: 1600px) and (-webkit-min-device-pixel-ratio: 1) {
	.ui.ordered.steps .step:before {
		font-size: 1rem;
	}

	.ui.step,
	.ui.steps .step {
		font-size: 0.6rem;
	}

	.title {
		font-size: 0.9rem !important;
	}
}
</style>
